import { render, staticRenderFns } from "./TS14.vue?vue&type=template&id=06aee156&scoped=true&"
import script from "./TS14.vue?vue&type=script&lang=js&"
export * from "./TS14.vue?vue&type=script&lang=js&"
import style0 from "./TS14.vue?vue&type=style&index=0&id=06aee156&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06aee156",
  null
  
)

export default component.exports